import { LucideIcon } from "lucide-react";

type ProjectImageProps = {
  src: string;
  alt: string;
  industry: string;
  icon: LucideIcon;
  priority?: boolean;
  className?: string;
};

export function ProjectImage({
  src,
  alt,
  industry,
  icon: Icon,
  priority = false,
  className = "",
}: ProjectImageProps) {
  return (
    <div
      className={`group relative overflow-hidden bg-space ${className}`}
      aria-label={`${industry} project image`}
    >
      <img
        src={src}
        srcSet={`${src} 1600w`}
        sizes="(min-width: 1280px) 33vw, (min-width: 768px) 50vw, 100vw"
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding={priority ? "sync" : "async"}
        className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(5,5,5,0.02),rgba(5,5,5,0.45))]" />
      <div className="absolute left-4 top-4 grid h-11 w-11 place-items-center rounded-2xl border border-white/15 bg-ink/55 text-white shadow-glass backdrop-blur-xl">
        <Icon className="h-5 w-5" aria-hidden="true" />
      </div>
      <div className="absolute bottom-4 left-4 rounded-full border border-white/15 bg-ink/55 px-4 py-2 text-xs font-semibold text-white backdrop-blur-xl">
        {industry}
      </div>
    </div>
  );
}
